/**
 * Purge elements from an array of elements
 * @param els Elements selected
 * @param purgeEls Elements to be purged from
 * @returns Elements after purging
 *
 * @example
 * ```ts
 * const els = document.querySelectorAll('.el');
 * const purgeEls = document.querySelectorAll('.purge-el');
 * const newEls = purgeEls(els, purgeEls);
 * ```
 */
export const purgeEls = (els: Element[], purgeEls: Element[]) => {
	const purgeCount = purgeEls.length;
	if (purgeCount === 0) return els;

	return els.filter((el) => {
		for (let i = 0; i < purgeCount; i++) {
			if (purgeEls[i].contains(el)) return false;
		}
		return true;
	});
};

export default purgeEls;
